import { render, staticRenderFns } from "./SxswIndex.vue?vue&type=template&id=c761ce7c&"
import script from "./SxswIndex.vue?vue&type=script&lang=js&"
export * from "./SxswIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports